import React from 'react'
import { useUser } from "../../../../hooks/use-user";
import StartQuizepage from '../Mcq/StartQuizepage';
import QuestionPage from '../Mcq/QuestionPage';
import StartQuizepage2 from '../Mcq/StartQuizepage2';
const DashHome = () => {
    const { data: user } = useUser();
  console.log(user);

  return (
    <div className=''>
    {user?.planName!=="TEST"?<StartQuizepage2/>:<QuestionPage/>}
    </div>
  )
}

export default DashHome
